import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { XCircleIcon } from '@heroicons/react/solid';

class _Modal extends React.PureComponent {
  render() {
    let info = '';
    const { version } = this.props;
    switch (version) {
      case 'feedback':
        info = <p>You made our day</p>;
        break;

      case 'request':
        info = (
          <p>
            We will notify you as soon as we get a permission from our client.If you don’t receive an email from us within 24 hours please check your
            Spam Box.
          </p>
        );

        break;

      case 'quote':
        info = (
          <p>
            Thank you for reaching out to us! We will review your request and provide pricing within 24 hours. If you don’t receive an email from us
            within 24 hours please check your Spam Box.
          </p>
        );

        break;

      default:
        info = (
          <p className="text-18 pl-50 pr-50 leading-20">
            Something great is headed your way! <br />
            <br />
            Our sales specialist will get back to you as soon as possible. If you don’t receive an email from us within 24 hours please check your
            Spam Box.
          </p>
        );

        break;
    }
    const { show, hide, loaded } = this.props;

    return (
      <>
        {show && (
          <div className="fixed z-10 inset-0 overflow-visible" aria-labelledby="modal-title" role="dialog" aria-modal="true">
            <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0 overflow-visible">
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="false" onClick={hide} />
              <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
                &#8203;
              </span>
              <div
                className={`relative inline-block align-bottom bg-white rounded-lg text-left  shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full`}
              >
                {/*{(loaded) &&*/}
                <div className={`absolute hide -top-10 -right-10 cursor-pointer`} onClick={hide}>
                  <XCircleIcon className="w-35 h-35 cursor-pointer text-purple" />
                </div>
                {/* }*/}
                <div className={`rounded-25 bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4`}>
                  <div className="sm:flex sm:items-center flex-col text-center p-10">
                    {loaded ? (
                      <>
                        <Image src="/images/thank-you.png" width={259} height={220} alt="Thank you !!!" layout="intrinsic" />
                        {info}
                        <span className={`text-45 uppercase font-black text-purple pt-10`}>THANK YOU</span>
                        <Link href="/" rel="noreferrer" aria-label="backHome">
                          <a className="p-10 rounded-5 text-white bg-green">Back Home</a>
                        </Link>
                      </>
                    ) : (
                      <>
                        <div className=" flex justify-center items-center p-10 text-20">Loading...</div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default _Modal;
